var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-bar flex-between"},_vm._l((_vm.navList),function(item,index){return _c('div',{key:index,staticClass:"nav-item flex-rowc",on:{"click":function($event){return _vm.handleClick(index)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }